
export default class InfringementControlBrowseEvents {
    public onlyCreatorEdit = true
    public onlyCreatorDelete = true
}
